
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import Cart from './pages/Shop/Cart';
import AuthLogin from './pages/Auth/AuthLogin';
import './index.css';
import Shop1 from './pages/Shop/Shop1';
import { GoogleOAuthProvider } from '@react-oauth/google'
import AdminDashboard from './pages/Admin/AdminDashboard';
import CheckoutPageNew from './pages/Shop/CheckoutPageNew';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Checkout from './pages/Shop/CheckoutPageNew';
import AdminProducts from './pages/Admin/AdminProduct.jsx';
import ProtectedRoute from "./utils/ProtectedRoute";
import { CartProvider } from './hooks/CartProvider';
import OrderHistory from './pages/OrderHistory';
import AdminOrders from './pages/Admin/AdminOrders.jsx';
import LandingPage from './pages/Landing/LandingPage.jsx';
import CommunityHomePage from './pages/community/CommunityHomePage.jsx';
import CommunityThreadsPage from './pages/community/CommunityThreadsPage.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
/*
 Developer Guide: main.jsx sets up routing. Add pages under src/pages and import them here.
*/
const GOOGLE_CLIENT_ID = "213256936857-fu998jg7cg98jkp11qng85lbh4ao5bo4.apps.googleusercontent.com";

const client = new QueryClient();

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <QueryClientProvider client={client}>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <Routes>
                <Route path="/" element={<App />}>

                  {/* 👇 All pages go inside as children */}
                  <Route index element={<LandingPage />} />
                  <Route path="authlogin" element={<AuthLogin />} />
                  <Route path="admin/products" element={<AdminProducts />} />
                  <Route path="admin/orders" element={<AdminOrders />} />
                  <Route path="shop" element={<Shop1 />} />
                  <Route path="cart" element={<Cart />} />
                  <Route path="CheckoutPageNew" element={<Checkout />} />
                  <Route path="admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                  <Route path="orders" element={<OrderHistory />} />
                  <Route path="community/:category" element={<CommunityHomePage />} />
                  <Route path="community/:category/threads" element={<CommunityThreadsPage />} />
                </Route>
              </Routes>
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
